/**
 * @generated SignedSource<<dc90cf979731704d7610c02589423b2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AutoRecordRuleLevel = "GROUP" | "USER" | "WORKSPACE";
import { FragmentRefs } from "relay-runtime";
export type AutoRecordRulesListItemAppliesTo$data = {
  readonly autoRecordRuleUsers: ReadonlyArray<{
    readonly user: {
      readonly id: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"AutoRecordRulesListItemUserPill">;
  }>;
  readonly id: string;
  readonly ruleLevel: AutoRecordRuleLevel;
  readonly " $fragmentType": "AutoRecordRulesListItemAppliesTo";
};
export type AutoRecordRulesListItemAppliesTo$key = {
  readonly " $data"?: AutoRecordRulesListItemAppliesTo$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordRulesListItemAppliesTo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutoRecordRulesListItemAppliesTo",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ruleLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AutoRecordRuleUser",
      "kind": "LinkedField",
      "name": "autoRecordRuleUsers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AutoRecordRulesListItemUserPill"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AutoRecordRule",
  "abstractKey": null
};
})();

(node as any).hash = "3c8854796858273743a1f97567de01ee";

export default node;
